export enum CreateActionType {
  GAME = 'game',
  TEAM = 'team'
}
